import React, { useState, useEffect } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem("adminToken"));
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [fetchError, setFetchError] = useState("");

  useEffect(() => {
    if (token) fetchSubmissions(token);
  }, [token]);

  const fetchSubmissions = async (t) => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/submissions`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setData(res.data);
    } catch {
      setFetchError("Failed to load data. Please log in again.");
      handleLogout();
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/admin/login`, {
        username,
        password,
      });
      localStorage.setItem("adminToken", res.data.token);
      setToken(res.data.token);
    } catch {
      setLoginError("Invalid username or password.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setToken(null);
    setData(null);
  };

  if (!token) {
    return (
      <div style={styles.loginPage}>
        <div style={styles.loginCard}>
          <h2 style={styles.loginTitle}>Admin Login</h2>
          <p style={styles.loginSubtitle}>Technology Movement Pakistan</p>
          <form onSubmit={handleLogin}>
            <div style={styles.field}>
              <label style={styles.label}>Username</label>
              <input
                style={styles.input}
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Password</label>
              <input
                style={styles.input}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            {loginError && <p style={styles.error}>{loginError}</p>}
            <button style={styles.button} type="submit" disabled={loading}>
              {loading ? "Logging in…" : "Login"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.dashboard}>
      <div style={styles.topBar}>
        <span style={styles.topBarTitle}>TMP Admin Dashboard</span>
        <button style={styles.logoutBtn} onClick={handleLogout}>
          Logout
        </button>
      </div>

      {fetchError && <p style={styles.error}>{fetchError}</p>}

      {data ? (
        <div style={styles.content}>
          <div style={styles.statCard}>
            <span style={styles.statNumber}>{data.count}</span>
            <span style={styles.statLabel}>Total Contact Form Submissions</span>
          </div>

          <h3 style={styles.tableTitle}>Recent Submissions</h3>
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.theadRow}>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Email</th>
                  <th style={styles.th}>WhatsApp</th>
                  <th style={styles.th}>Date</th>
                </tr>
              </thead>
              <tbody>
                {data.records.map((r, i) => (
                  <tr key={r._id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                    <td style={styles.td}>{i + 1}</td>
                    <td style={styles.td}>{r.name}</td>
                    <td style={styles.td}>{r.email}</td>
                    <td style={styles.td}>{r.whatsappNumber}</td>
                    <td style={styles.td}>
                      {new Date(r.createdAt).toLocaleDateString("en-PK", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {data.records.length === 0 && (
              <p style={styles.empty}>No submissions yet.</p>
            )}
          </div>
        </div>
      ) : (
        <p style={styles.loading}>Loading…</p>
      )}
    </div>
  );
}

const styles = {
  loginPage: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0f0f0f",
  },
  loginCard: {
    background: "#1a1a1a",
    border: "1px solid #2e2e2e",
    borderRadius: 12,
    padding: "40px 36px",
    width: "100%",
    maxWidth: 380,
  },
  loginTitle: {
    color: "#ffffff",
    margin: "0 0 4px",
    fontSize: 24,
    fontWeight: 700,
  },
  loginSubtitle: {
    color: "#888",
    margin: "0 0 28px",
    fontSize: 13,
  },
  field: { marginBottom: 18 },
  label: {
    display: "block",
    color: "#aaa",
    fontSize: 13,
    marginBottom: 6,
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    background: "#111",
    border: "1px solid #333",
    borderRadius: 8,
    color: "#fff",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
  },
  button: {
    width: "100%",
    padding: "11px",
    background: "#e63946",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 8,
  },
  error: { color: "#e63946", fontSize: 13, margin: "8px 0" },
  dashboard: { minHeight: "100vh", background: "#0f0f0f", fontFamily: "sans-serif" },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 32px",
    background: "#1a1a1a",
    borderBottom: "1px solid #2e2e2e",
  },
  topBarTitle: { color: "#fff", fontWeight: 700, fontSize: 18 },
  logoutBtn: {
    background: "transparent",
    border: "1px solid #444",
    color: "#aaa",
    padding: "6px 16px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
  },
  content: { padding: "32px" },
  statCard: {
    background: "#1a1a1a",
    border: "1px solid #2e2e2e",
    borderRadius: 12,
    padding: "28px 32px",
    display: "inline-flex",
    flexDirection: "column",
    marginBottom: 36,
  },
  statNumber: { color: "#e63946", fontSize: 48, fontWeight: 800, lineHeight: 1 },
  statLabel: { color: "#888", fontSize: 14, marginTop: 8 },
  tableTitle: { color: "#fff", marginBottom: 16, fontWeight: 600 },
  tableWrapper: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", minWidth: 600 },
  theadRow: { background: "#1a1a1a" },
  th: {
    color: "#888",
    fontSize: 12,
    textTransform: "uppercase",
    padding: "10px 14px",
    textAlign: "left",
    borderBottom: "1px solid #2e2e2e",
  },
  td: { color: "#ddd", fontSize: 14, padding: "12px 14px" },
  trEven: { background: "#111" },
  trOdd: { background: "#141414" },
  empty: { color: "#666", textAlign: "center", padding: 32 },
  loading: { color: "#666", textAlign: "center", marginTop: 80 },
};
